/**
* description:
* File of container Billing Container
*
* data : 2017-08-03
*/

import Vue from 'vue';
import store from '@/store';
import { mapGetters } from 'vuex';

// COMPONENTS //////////////////////////////////////////////////////////////////
import BillingSummary from '@/components/Billing/BillingSummary';
import BillingSearchTerms from '@/components/Billing/BillingSearchTerms';
import BillingDetails from '@/components/Billing/BillingDetails';

// CONTAINER ///////////////////////////////////////////////////////////////////
const Billing = {
  components: { BillingSummary, BillingSearchTerms, BillingDetails },
  store,
  computed: {
    ...mapGetters(['billingList', 'billingListActualPage', 'pendingStoreActions', 'subscriber']),
  },
  template: `
    <div class="container-fluid animated fadeIn">
      <div class="row">
        <div class="col-xs-12 col-md-7">
          <billing-summary
            :billing-list="billingList"
            :is-loading-data="pendingStoreActions.includes('getBillingList')"
            :subscriber="subscriber" />
        </div>
        <div class="col-xs-12 col-md-5">
          <billing-search-terms :billing-list="billingList" :is-loading-data="pendingStoreActions.includes('getBillingList')" />
        </div>
        <div class="col-xs-12">
          <billing-details
            :billing-list="billingList"
            :billing-list-actual-page="billingListActualPage"
            :is-loading-data="pendingStoreActions.includes('getBillingList')"
            :subscriber="subscriber"
          />
        </div>
      </div>
    </div>
  `,
};

export default Vue
  .component('Billing', Billing);



// WEBPACK FOOTER //
// ./src/containers/Billing/index.js